export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 2a2 2 0 100 4 2 2 0 000-4zM4 4a4 4 0 118 0 4 4 0 01-8 0zm3.941 6c-1.625 0-3.114.646-4.253 1.726a1 1 0 11-1.376-1.452C3.796 8.867 5.77 8 7.942 8c.814 0 1.603.122 2.35.35a1 1 0 11-.584 1.913A6.025 6.025 0 007.94 10zM14 11a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1v-1z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};